import { renderPhoneNumber } from '@axo/shared/util/formatters';

export function defaultFormatter(value: unknown) {
  return value ? String(value) : '-';
}

export function defaultPhoneNumberFormatter(code: unknown, number: unknown) {
  return (
    renderPhoneNumber({
      phoneCountryCode: code ? String(code) : undefined,
      phoneNumber: number ? String(number) : undefined,
    }) || '-'
  );
}
